import React from "react";
import { Box, Container, Typography, Link as MuiLink } from "@mui/material";

const Hero = () => {
  return (
    <Box
      id="hero"
      sx={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        pt: 10,
        overflow: "hidden",
        backgroundImage:
          "radial-gradient(circle at 2px 2px, rgba(0, 240, 255, 0.05) 1px, transparent 0)",
        backgroundSize: "40px 40px",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: 300, md: 600 },
          height: { xs: 300, md: 600 },
          bgcolor: "rgba(0, 240, 255, 0.05)",
          borderRadius: "50%",
          filter: "blur(120px)",
          animation: "pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        }}
      />

      <Container maxWidth="lg" sx={{ px: 3, position: "relative", zIndex: 10 }}>
        <Box sx={{ maxWidth: "56rem" }}>
          <Typography
            sx={{
              fontFamily: "mono",
              color: "primary.main",
              fontSize: "0.875rem",
              mb: 3,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
            }}
          >
            Software Developer
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", sm: "3.5rem", md: "5.5rem" }, // Scaled down for mobile
              fontWeight: 700,
              lineHeight: 1.2,
              mb: 4,
              letterSpacing: "-0.02em",
              background: "linear-gradient(135deg, #ffffff 0%, #94a3b8 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Ahmad Hanafi / <br />
            Engineering Intuitive Experiences
          </Typography>
          <Typography
            sx={{
              fontSize: "1.25rem",
              color: "text.secondary",
              maxWidth: "42rem",
              lineHeight: 1.7,
              mb: 6,
            }}
          >
            A dedicated and quick-learning Software Developer with nearly three
            years of experience creating clean, responsive, and high-performance
            applications for web and mobile platforms.
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
            <MuiLink
              href="#works"
              sx={{
                bgcolor: "white",
                color: "custom.midnight",
                px: 4,
                py: 2,
                fontFamily: "mono",
                fontSize: "0.875rem",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                textDecoration: "none",
                transition: "all 0.3s",
                "&:hover": { bgcolor: "primary.main" },
              }}
            >
              View Projects
            </MuiLink>
            <MuiLink
              href="#contact"
              sx={{
                border: "1px solid",
                borderColor: "custom.white10",
                color: "white",
                px: 4,
                py: 2,
                fontFamily: "mono",
                fontSize: "0.875rem",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                textDecoration: "none",
                transition: "all 0.3s",
                "&:hover": { borderColor: "rgba(0, 240, 255, 0.5)" },
              }}
            >
              Initiate Contact
            </MuiLink>
          </Box>
        </Box>
      </Container>

      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          position: "absolute",
          bottom: 40,
          left: 24,
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: "1px",
            height: 48,
            bgcolor: "custom.white20",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "50%",
              bgcolor: "primary.main",
              animation: "bounce 2s infinite",
            }}
          />
        </Box>
        <Typography
          sx={{
            fontFamily: "mono",
            fontSize: "10px",
            textTransform: "uppercase",
            letterSpacing: "0.2em",
            color: "text.secondary",
          }}
        >
          Scroll to explore
        </Typography>
      </Box>
    </Box>
  );
};

export default Hero;
